module.exports = __webpack_public_path__ + "img/icon_5_72.9b4a74f4.png";